"use strict";
import EmailViewer from "../accounts_payable/indexer/email_viewer";
export default {
  emailMessages: function(messages, documentFromEmail, callback) {
    return /* @__PURE__ */ React.createElement("div", { className: "email-viewer__thread-container" }, this.emailMessagesDetail(messages, documentFromEmail, callback));
  },
  emailMessagesDetail: function(messages, documentFromEmail, callback) {
    return messages.map((email) => {
      return /* @__PURE__ */ React.createElement("div", { className: "email-viewer__thread-item", key: "email-detail-" + email.id }, /* @__PURE__ */ React.createElement(
        EmailViewer,
        {
          message: email,
          documentFromEmail,
          documentFromEmailCallback: callback
        }
      ));
    });
  }
};
